import React from "react";

const BurgerIcon = () => {
  return (
    <svg
      width="57"
      height="20"
      viewBox="0 0 57 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="57" height="4" rx="2" fill="white" />
      <rect y="16" width="57" height="4" rx="2" fill="white" />
      <rect y="8" width="57" height="4" rx="2" fill="white" />
    </svg>
  );
};

export default BurgerIcon;
